import '../../assets/index49.css';var ft = Object.defineProperty, pt = Object.defineProperties;
var St = Object.getOwnPropertyDescriptors;
var me = Object.getOwnPropertySymbols;
var $e = Object.prototype.hasOwnProperty, Xe = Object.prototype.propertyIsEnumerable;
var Fe = (e, t, r) => t in e ? ft(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, f = (e, t) => {
  for (var r in t || (t = {}))
    $e.call(t, r) && Fe(e, r, t[r]);
  if (me)
    for (var r of me(t))
      Xe.call(t, r) && Fe(e, r, t[r]);
  return e;
}, v = (e, t) => pt(e, St(t));
var x = (e, t) => {
  var r = {};
  for (var o in e)
    $e.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
  if (e != null && me)
    for (var o of me(e))
      t.indexOf(o) < 0 && Xe.call(e, o) && (r[o] = e[o]);
  return r;
};
import { jsx as s, jsxs as q, Fragment as vt } from "react/jsx-runtime";
import { Pagination as yt } from "../Pagination/index.js";
import { useRef as M, useEffect as $, useMemo as Ue, useCallback as gt, forwardRef as W, useState as g, useLayoutEffect as wt } from "react";
import { Button as ge } from "../Button/index.js";
import { TextField as Tt } from "../TextField/index.js";
import { Menu as we } from "../Menu/index.js";
import { T as Oe } from "../../index-ebeTA-Hp.js";
import { Checkbox as Ie } from "../Checkbox/index.js";
import { ArrowDownFarFAIcon as _t, ArrowUpFarFAIcon as Ct, FilterFarFAIcon as Pt, XMarkFarFAIcon as xt } from "../Icons/index.js";
import { S as Me } from "../../Stack-CvxmgMMn.js";
import { r as xe } from "../../rem-CMQJ_ZTp.js";
import { b as Be } from "../../get-size-BzhHC8s2.js";
import { u as Ae, c as ze } from "../../use-styles-BXCSW-9F.js";
import { b as le, B as K, j as ie, f as Te } from "../../factory-BnRIVbT0.js";
import { c as De } from "../../create-safe-context-DqDyoPVE.js";
import { r as At } from "../../use-floating-auto-update-BPNMj5CZ.js";
import { u as zt } from "../../use-isomorphic-effect-CiIycTKV.js";
import { u as se } from "../../use-merged-ref-n551Tfbr.js";
import { u as Dt } from "../../DirectionProvider-CT8S13Cp.js";
import { t as fe } from "../../to-int-CHbRl5M-.js";
import { F as Ve } from "../../Flex-B_Eo0AIL.js";
function Z(e) {
  const t = M(e);
  return $(() => {
    t.current = e;
  }), Ue(() => (...r) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...r);
  }, []);
}
const Rt = () => {
};
function pe(e, t) {
  const r = typeof t == "number" ? t : t.delay, o = typeof t == "number" ? !1 : t.flushOnUnmount, c = Z(e), l = M(0), n = Object.assign(
    gt(
      (...d) => {
        window.clearTimeout(l.current);
        const u = () => {
          l.current !== 0 && (l.current = 0, c(...d));
        };
        n.flush = u, l.current = window.setTimeout(u, r);
      },
      [c, r]
    ),
    { flush: Rt }
  );
  return $(
    () => () => {
      window.clearTimeout(l.current), o && n.flush();
    },
    [n, o]
  ), n;
}
const [kt, B] = De(
  "ScrollArea.Root component was not found in tree"
);
function ne(e, t) {
  const r = Z(t);
  zt(() => {
    let o = 0;
    if (e) {
      const c = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(r);
      });
      return c.observe(e), () => {
        window.cancelAnimationFrame(o), c.unobserve(e);
      };
    }
  }, [e, r]);
}
const Nt = W((e, t) => {
  const b = e, { style: r } = b, o = x(b, ["style"]), c = B(), [l, n] = g(0), [d, u] = g(0), m = !!(l && d);
  return ne(c.scrollbarX, () => {
    var i;
    const h = ((i = c.scrollbarX) == null ? void 0 : i.offsetHeight) || 0;
    c.onCornerHeightChange(h), u(h);
  }), ne(c.scrollbarY, () => {
    var i;
    const h = ((i = c.scrollbarY) == null ? void 0 : i.offsetWidth) || 0;
    c.onCornerWidthChange(h), n(h);
  }), m ? /* @__PURE__ */ s("div", v(f({}, o), { ref: t, style: v(f({}, r), { width: l, height: d }) })) : null;
}), Lt = W((e, t) => {
  const r = B(), o = !!(r.scrollbarX && r.scrollbarY);
  return r.type !== "scroll" && o ? /* @__PURE__ */ s(Nt, v(f({}, e), { ref: t })) : null;
}), Et = {
  scrollHideDelay: 1e3,
  type: "hover"
}, je = W((e, t) => {
  const z = le("ScrollAreaRoot", Et, e), { type: o, scrollHideDelay: c, scrollbars: l } = z, n = x(z, ["type", "scrollHideDelay", "scrollbars"]), [d, u] = g(null), [m, b] = g(null), [h, i] = g(null), [S, p] = g(null), [A, C] = g(null), [R, H] = g(0), [L, Y] = g(0), [P, V] = g(!1), [N, X] = g(!1), y = se(t, (F) => u(F));
  return /* @__PURE__ */ s(
    kt,
    {
      value: {
        type: o,
        scrollHideDelay: c,
        scrollArea: d,
        viewport: m,
        onViewportChange: b,
        content: h,
        onContentChange: i,
        scrollbarX: S,
        onScrollbarXChange: p,
        scrollbarXEnabled: P,
        onScrollbarXEnabledChange: V,
        scrollbarY: A,
        onScrollbarYChange: C,
        scrollbarYEnabled: N,
        onScrollbarYEnabledChange: X,
        onCornerWidthChange: H,
        onCornerHeightChange: Y
      },
      children: /* @__PURE__ */ s(
        K,
        v(f({}, n), {
          ref: y,
          __vars: {
            "--sa-corner-width": l !== "xy" ? "0px" : `${R}px`,
            "--sa-corner-height": l !== "xy" ? "0px" : `${L}px`
          }
        })
      )
    }
  );
});
je.displayName = "@mantine/core/ScrollAreaRoot";
function qe(e, t) {
  const r = e / t;
  return Number.isNaN(r) ? 0 : r;
}
function Se(e) {
  const t = qe(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - r) * t;
  return Math.max(o, 18);
}
function Je(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (r - e[0]);
  };
}
function Ht(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
function Ye(e, t, r = "ltr") {
  const o = Se(t), c = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, l = t.scrollbar.size - c, n = t.content - t.viewport, d = l - o, u = r === "ltr" ? [0, n] : [n * -1, 0], m = Ht(e, u);
  return Je([0, n], [0, d])(m);
}
function Wt(e, t, r, o = "ltr") {
  const c = Se(r), l = c / 2, n = t || l, d = c - n, u = r.scrollbar.paddingStart + n, m = r.scrollbar.size - r.scrollbar.paddingEnd - d, b = r.content - r.viewport, h = o === "ltr" ? [0, b] : [b * -1, 0];
  return Je([u, m], h)(e);
}
function Ge(e, t) {
  return e > 0 && e < t;
}
function Q(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return (o) => {
    e == null || e(o), (r === !1 || !o.defaultPrevented) && (t == null || t(o));
  };
}
const [Ft, Ze] = De(
  "ScrollAreaScrollbar was not found in tree"
), Qe = W((e, t) => {
  const X = e, {
    sizes: r,
    hasThumb: o,
    onThumbChange: c,
    onThumbPointerUp: l,
    onThumbPointerDown: n,
    onThumbPositionChange: d,
    onDragScroll: u,
    onWheelScroll: m,
    onResize: b
  } = X, h = x(X, [
    "sizes",
    "hasThumb",
    "onThumbChange",
    "onThumbPointerUp",
    "onThumbPointerDown",
    "onThumbPositionChange",
    "onDragScroll",
    "onWheelScroll",
    "onResize"
  ]), i = B(), [S, p] = g(null), A = se(t, (y) => p(y)), C = M(null), R = M(""), { viewport: H } = i, L = r.content - r.viewport, Y = Z(m), P = Z(d), V = pe(b, 10), N = (y) => {
    if (C.current) {
      const z = y.clientX - C.current.left, F = y.clientY - C.current.top;
      u({ x: z, y: F });
    }
  };
  return $(() => {
    const y = (z) => {
      const F = z.target;
      (S == null ? void 0 : S.contains(F)) && Y(z, L);
    };
    return document.addEventListener("wheel", y, { passive: !1 }), () => document.removeEventListener("wheel", y, { passive: !1 });
  }, [H, S, L, Y]), $(P, [r, P]), ne(S, V), ne(i.content, V), /* @__PURE__ */ s(
    Ft,
    {
      value: {
        scrollbar: S,
        hasThumb: o,
        onThumbChange: Z(c),
        onThumbPointerUp: Z(l),
        onThumbPositionChange: P,
        onThumbPointerDown: Z(n)
      },
      children: /* @__PURE__ */ s(
        "div",
        v(f({}, h), {
          ref: A,
          "data-mantine-scrollbar": !0,
          style: f({ position: "absolute" }, h.style),
          onPointerDown: Q(e.onPointerDown, (y) => {
            y.preventDefault(), y.button === 0 && (y.target.setPointerCapture(y.pointerId), C.current = S.getBoundingClientRect(), R.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", N(y));
          }),
          onPointerMove: Q(e.onPointerMove, N),
          onPointerUp: Q(e.onPointerUp, (y) => {
            const z = y.target;
            z.hasPointerCapture(y.pointerId) && (y.preventDefault(), z.releasePointerCapture(y.pointerId));
          }),
          onLostPointerCapture: () => {
            document.body.style.webkitUserSelect = R.current, C.current = null;
          }
        })
      )
    }
  );
}), Ke = W(
  (e, t) => {
    const h = e, { sizes: r, onSizesChange: o, style: c } = h, l = x(h, ["sizes", "onSizesChange", "style"]), n = B(), [d, u] = g(), m = M(null), b = se(t, m, n.onScrollbarXChange);
    return $(() => {
      m.current && u(getComputedStyle(m.current));
    }, [m]), /* @__PURE__ */ s(
      Qe,
      v(f({
        "data-orientation": "horizontal"
      }, l), {
        ref: b,
        sizes: r,
        style: v(f({}, c), {
          "--sa-thumb-width": `${Se(r)}px`
        }),
        onThumbPointerDown: (i) => e.onThumbPointerDown(i.x),
        onDragScroll: (i) => e.onDragScroll(i.x),
        onWheelScroll: (i, S) => {
          if (n.viewport) {
            const p = n.viewport.scrollLeft + i.deltaX;
            e.onWheelScroll(p), Ge(p, S) && i.preventDefault();
          }
        },
        onResize: () => {
          m.current && n.viewport && d && o({
            content: n.viewport.scrollWidth,
            viewport: n.viewport.offsetWidth,
            scrollbar: {
              size: m.current.clientWidth,
              paddingStart: fe(d.paddingLeft),
              paddingEnd: fe(d.paddingRight)
            }
          });
        }
      })
    );
  }
);
Ke.displayName = "@mantine/core/ScrollAreaScrollbarX";
const et = W(
  (e, t) => {
    const h = e, { sizes: r, onSizesChange: o, style: c } = h, l = x(h, ["sizes", "onSizesChange", "style"]), n = B(), [d, u] = g(), m = M(null), b = se(t, m, n.onScrollbarYChange);
    return $(() => {
      m.current && u(window.getComputedStyle(m.current));
    }, []), /* @__PURE__ */ s(
      Qe,
      v(f({}, l), {
        "data-orientation": "vertical",
        ref: b,
        sizes: r,
        style: f({
          "--sa-thumb-height": `${Se(r)}px`
        }, c),
        onThumbPointerDown: (i) => e.onThumbPointerDown(i.y),
        onDragScroll: (i) => e.onDragScroll(i.y),
        onWheelScroll: (i, S) => {
          if (n.viewport) {
            const p = n.viewport.scrollTop + i.deltaY;
            e.onWheelScroll(p), Ge(p, S) && i.preventDefault();
          }
        },
        onResize: () => {
          m.current && n.viewport && d && o({
            content: n.viewport.scrollHeight,
            viewport: n.viewport.offsetHeight,
            scrollbar: {
              size: m.current.clientHeight,
              paddingStart: fe(d.paddingTop),
              paddingEnd: fe(d.paddingBottom)
            }
          });
        }
      })
    );
  }
);
et.displayName = "@mantine/core/ScrollAreaScrollbarY";
const ve = W((e, t) => {
  const S = e, { orientation: r = "vertical" } = S, o = x(S, ["orientation"]), { dir: c } = Dt(), l = B(), n = M(null), d = M(0), [u, m] = g({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), b = qe(u.viewport, u.content), h = v(f({}, o), {
    sizes: u,
    onSizesChange: m,
    hasThumb: b > 0 && b < 1,
    onThumbChange: (p) => {
      n.current = p;
    },
    onThumbPointerUp: () => {
      d.current = 0;
    },
    onThumbPointerDown: (p) => {
      d.current = p;
    }
  }), i = (p, A) => Wt(p, d.current, u, A);
  return r === "horizontal" ? /* @__PURE__ */ s(
    Ke,
    v(f({}, h), {
      ref: t,
      onThumbPositionChange: () => {
        if (l.viewport && n.current) {
          const p = l.viewport.scrollLeft, A = Ye(p, u, c);
          n.current.style.transform = `translate3d(${A}px, 0, 0)`;
        }
      },
      onWheelScroll: (p) => {
        l.viewport && (l.viewport.scrollLeft = p);
      },
      onDragScroll: (p) => {
        l.viewport && (l.viewport.scrollLeft = i(p, c));
      }
    })
  ) : r === "vertical" ? /* @__PURE__ */ s(
    et,
    v(f({}, h), {
      ref: t,
      onThumbPositionChange: () => {
        if (l.viewport && n.current) {
          const p = l.viewport.scrollTop, A = Ye(p, u);
          u.scrollbar.size === 0 ? n.current.style.setProperty("--thumb-opacity", "0") : n.current.style.setProperty("--thumb-opacity", "1"), n.current.style.transform = `translate3d(0, ${A}px, 0)`;
        }
      },
      onWheelScroll: (p) => {
        l.viewport && (l.viewport.scrollTop = p);
      },
      onDragScroll: (p) => {
        l.viewport && (l.viewport.scrollTop = i(p));
      }
    })
  ) : null;
});
ve.displayName = "@mantine/core/ScrollAreaScrollbarVisible";
const Re = W(
  (e, t) => {
    const r = B(), m = e, { forceMount: o } = m, c = x(m, ["forceMount"]), [l, n] = g(!1), d = e.orientation === "horizontal", u = pe(() => {
      if (r.viewport) {
        const b = r.viewport.offsetWidth < r.viewport.scrollWidth, h = r.viewport.offsetHeight < r.viewport.scrollHeight;
        n(d ? b : h);
      }
    }, 10);
    return ne(r.viewport, u), ne(r.content, u), o || l ? /* @__PURE__ */ s(
      ve,
      v(f({
        "data-state": l ? "visible" : "hidden"
      }, c), {
        ref: t
      })
    ) : null;
  }
);
Re.displayName = "@mantine/core/ScrollAreaScrollbarAuto";
const tt = W(
  (e, t) => {
    const d = e, { forceMount: r } = d, o = x(d, ["forceMount"]), c = B(), [l, n] = g(!1);
    return $(() => {
      const { scrollArea: u } = c;
      let m = 0;
      if (u) {
        const b = () => {
          window.clearTimeout(m), n(!0);
        }, h = () => {
          m = window.setTimeout(() => n(!1), c.scrollHideDelay);
        };
        return u.addEventListener("pointerenter", b), u.addEventListener("pointerleave", h), () => {
          window.clearTimeout(m), u.removeEventListener("pointerenter", b), u.removeEventListener("pointerleave", h);
        };
      }
    }, [c.scrollArea, c.scrollHideDelay]), r || l ? /* @__PURE__ */ s(
      Re,
      v(f({
        "data-state": l ? "visible" : "hidden"
      }, o), {
        ref: t
      })
    ) : null;
  }
);
tt.displayName = "@mantine/core/ScrollAreaScrollbarHover";
const $t = W(
  (e, t) => {
    const m = e, { forceMount: r } = m, o = x(m, ["forceMount"]), c = B(), l = e.orientation === "horizontal", [n, d] = g("hidden"), u = pe(() => d("idle"), 100);
    return $(() => {
      if (n === "idle") {
        const b = window.setTimeout(() => d("hidden"), c.scrollHideDelay);
        return () => window.clearTimeout(b);
      }
    }, [n, c.scrollHideDelay]), $(() => {
      const { viewport: b } = c, h = l ? "scrollLeft" : "scrollTop";
      if (b) {
        let i = b[h];
        const S = () => {
          const p = b[h];
          i !== p && (d("scrolling"), u()), i = p;
        };
        return b.addEventListener("scroll", S), () => b.removeEventListener("scroll", S);
      }
    }, [c.viewport, l, u]), r || n !== "hidden" ? /* @__PURE__ */ s(
      ve,
      v(f({
        "data-state": n === "hidden" ? "hidden" : "visible"
      }, o), {
        ref: t,
        onPointerEnter: Q(e.onPointerEnter, () => d("interacting")),
        onPointerLeave: Q(e.onPointerLeave, () => d("idle"))
      })
    ) : null;
  }
), _e = W(
  (e, t) => {
    const u = e, { forceMount: r } = u, o = x(u, ["forceMount"]), c = B(), { onScrollbarXEnabledChange: l, onScrollbarYEnabledChange: n } = c, d = e.orientation === "horizontal";
    return $(() => (d ? l(!0) : n(!0), () => {
      d ? l(!1) : n(!1);
    }), [d, l, n]), c.type === "hover" ? /* @__PURE__ */ s(tt, v(f({}, o), { ref: t, forceMount: r })) : c.type === "scroll" ? /* @__PURE__ */ s($t, v(f({}, o), { ref: t, forceMount: r })) : c.type === "auto" ? /* @__PURE__ */ s(Re, v(f({}, o), { ref: t, forceMount: r })) : c.type === "always" ? /* @__PURE__ */ s(ve, v(f({}, o), { ref: t })) : null;
  }
);
_e.displayName = "@mantine/core/ScrollAreaScrollbar";
function Xt(e, t = () => {
}) {
  let r = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function c() {
    const l = { left: e.scrollLeft, top: e.scrollTop }, n = r.left !== l.left, d = r.top !== l.top;
    (n || d) && t(), r = l, o = window.requestAnimationFrame(c);
  }(), () => window.cancelAnimationFrame(o);
}
const rt = W((e, t) => {
  const b = e, { style: r } = b, o = x(b, ["style"]), c = B(), l = Ze(), { onThumbPositionChange: n } = l, d = se(t, (h) => l.onThumbChange(h)), u = M(void 0), m = pe(() => {
    u.current && (u.current(), u.current = void 0);
  }, 100);
  return $(() => {
    const { viewport: h } = c;
    if (h) {
      const i = () => {
        if (m(), !u.current) {
          const S = Xt(h, n);
          u.current = S, n();
        }
      };
      return n(), h.addEventListener("scroll", i), () => h.removeEventListener("scroll", i);
    }
  }, [c.viewport, m, n]), /* @__PURE__ */ s(
    "div",
    v(f({
      "data-state": l.hasThumb ? "visible" : "hidden"
    }, o), {
      ref: d,
      style: f({
        width: "var(--sa-thumb-width)",
        height: "var(--sa-thumb-height)"
      }, r),
      onPointerDownCapture: Q(e.onPointerDownCapture, (h) => {
        const S = h.target.getBoundingClientRect(), p = h.clientX - S.left, A = h.clientY - S.top;
        l.onThumbPointerDown({ x: p, y: A });
      }),
      onPointerUp: Q(e.onPointerUp, l.onThumbPointerUp)
    })
  );
});
rt.displayName = "@mantine/core/ScrollAreaThumb";
const Ce = W(
  (e, t) => {
    const l = e, { forceMount: r } = l, o = x(l, ["forceMount"]), c = Ze();
    return r || c.hasThumb ? /* @__PURE__ */ s(rt, f({ ref: t }, o)) : null;
  }
);
Ce.displayName = "@mantine/core/ScrollAreaThumb";
const ot = W(
  (c, o) => {
    var l = c, { children: e, style: t } = l, r = x(l, ["children", "style"]);
    const n = B(), d = se(o, n.onViewportChange);
    return /* @__PURE__ */ s(
      K,
      v(f({}, r), {
        ref: d,
        style: f({
          overflowX: n.scrollbarXEnabled ? "scroll" : "hidden",
          overflowY: n.scrollbarYEnabled ? "scroll" : "hidden"
        }, t),
        children: /* @__PURE__ */ s("div", { style: { minWidth: "100%", display: "table" }, ref: n.onContentChange, children: e })
      })
    );
  }
);
ot.displayName = "@mantine/core/ScrollAreaViewport";
var ke = { root: "m_d57069b5", viewport: "m_c0783ff9", viewportInner: "m_f8f631dd", scrollbar: "m_c44ba933", thumb: "m_d8b5e363", corner: "m_21657268" };
const nt = {
  scrollHideDelay: 1e3,
  type: "hover",
  scrollbars: "xy"
}, Ot = ze(
  (e, { scrollbarSize: t, overscrollBehavior: r }) => ({
    root: {
      "--scrollarea-scrollbar-size": xe(t),
      "--scrollarea-over-scroll-behavior": r
    }
  })
), de = ie((e, t) => {
  const r = le("ScrollArea", nt, e), E = r, {
    classNames: o,
    className: c,
    style: l,
    styles: n,
    unstyled: d,
    scrollbarSize: u,
    vars: m,
    type: b,
    scrollHideDelay: h,
    viewportProps: i,
    viewportRef: S,
    onScrollPositionChange: p,
    children: A,
    offsetScrollbars: C,
    scrollbars: R,
    onBottomReached: H,
    onTopReached: L,
    overscrollBehavior: Y
  } = E, P = x(E, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "scrollbarSize",
    "vars",
    "type",
    "scrollHideDelay",
    "viewportProps",
    "viewportRef",
    "onScrollPositionChange",
    "children",
    "offsetScrollbars",
    "scrollbars",
    "onBottomReached",
    "onTopReached",
    "overscrollBehavior"
  ]), [V, N] = g(!1), [X, y] = g(!1), [z, F] = g(!1), O = Ae({
    name: "ScrollArea",
    props: r,
    classes: ke,
    className: c,
    style: l,
    classNames: o,
    styles: n,
    unstyled: d,
    vars: m,
    varsResolver: Ot
  }), U = M(null), te = At([S, U]);
  return $(() => {
    if (!U.current || C !== "present")
      return;
    const I = U.current, J = new ResizeObserver(() => {
      const { scrollHeight: re, clientHeight: ae, scrollWidth: oe, clientWidth: ye } = I;
      y(re > ae), F(oe > ye);
    });
    return J.observe(I), () => J.disconnect();
  }, [U, C]), /* @__PURE__ */ q(
    je,
    v(f(f({
      type: b === "never" ? "always" : b,
      scrollHideDelay: h,
      ref: t,
      scrollbars: R
    }, O("root")), P), {
      children: [
        /* @__PURE__ */ s(
          ot,
          v(f(f({}, i), O("viewport", { style: i == null ? void 0 : i.style })), {
            ref: te,
            "data-offset-scrollbars": C === !0 ? "xy" : C || void 0,
            "data-scrollbars": R || void 0,
            "data-horizontal-hidden": C === "present" && !z ? "true" : void 0,
            "data-vertical-hidden": C === "present" && !X ? "true" : void 0,
            onScroll: (I) => {
              var oe;
              (oe = i == null ? void 0 : i.onScroll) == null || oe.call(i, I), p == null || p({ x: I.currentTarget.scrollLeft, y: I.currentTarget.scrollTop });
              const { scrollTop: J, scrollHeight: re, clientHeight: ae } = I.currentTarget;
              J - (re - ae) >= 0 && (H == null || H()), J === 0 && (L == null || L());
            },
            children: A
          })
        ),
        (R === "xy" || R === "x") && /* @__PURE__ */ s(
          _e,
          v(f({}, O("scrollbar")), {
            orientation: "horizontal",
            "data-hidden": b === "never" || !z || void 0,
            forceMount: !0,
            onMouseEnter: () => N(!0),
            onMouseLeave: () => N(!1),
            children: /* @__PURE__ */ s(Ce, f({}, O("thumb")))
          })
        ),
        (R === "xy" || R === "y") && /* @__PURE__ */ s(
          _e,
          v(f({}, O("scrollbar")), {
            orientation: "vertical",
            "data-hidden": b === "never" || !X || void 0,
            forceMount: !0,
            onMouseEnter: () => N(!0),
            onMouseLeave: () => N(!1),
            children: /* @__PURE__ */ s(Ce, f({}, O("thumb")))
          })
        ),
        /* @__PURE__ */ s(
          Lt,
          v(f({}, O("corner")), {
            "data-hovered": V || void 0,
            "data-hidden": b === "never" || void 0
          })
        )
      ]
    })
  );
});
de.displayName = "@mantine/core/ScrollArea";
const Ne = ie((e, t) => {
  const P = le("ScrollAreaAutosize", nt, e), {
    children: r,
    classNames: o,
    styles: c,
    scrollbarSize: l,
    scrollHideDelay: n,
    type: d,
    dir: u,
    offsetScrollbars: m,
    viewportRef: b,
    onScrollPositionChange: h,
    unstyled: i,
    variant: S,
    viewportProps: p,
    scrollbars: A,
    style: C,
    vars: R,
    onBottomReached: H,
    onTopReached: L
  } = P, Y = x(P, [
    "children",
    "classNames",
    "styles",
    "scrollbarSize",
    "scrollHideDelay",
    "type",
    "dir",
    "offsetScrollbars",
    "viewportRef",
    "onScrollPositionChange",
    "unstyled",
    "variant",
    "viewportProps",
    "scrollbars",
    "style",
    "vars",
    "onBottomReached",
    "onTopReached"
  ]);
  return /* @__PURE__ */ s(K, v(f({}, Y), { ref: t, style: [{ display: "flex", overflow: "auto" }, C], children: /* @__PURE__ */ s(K, { style: { display: "flex", flexDirection: "column", flex: 1 }, children: /* @__PURE__ */ s(
    de,
    {
      classNames: o,
      styles: c,
      scrollHideDelay: n,
      scrollbarSize: l,
      type: d,
      dir: u,
      offsetScrollbars: m,
      viewportRef: b,
      onScrollPositionChange: h,
      unstyled: i,
      variant: S,
      viewportProps: p,
      vars: R,
      scrollbars: A,
      onBottomReached: H,
      onTopReached: L,
      children: r
    }
  ) }) }));
});
de.classes = ke;
Ne.displayName = "@mantine/core/ScrollAreaAutosize";
Ne.classes = ke;
de.Autosize = Ne;
const [It, Mt] = De(
  "Table component was not found in the tree"
);
var ue = { table: "m_b23fa0ef", th: "m_4e7aa4f3", tr: "m_4e7aa4fd", td: "m_4e7aa4ef", tbody: "m_b2404537", thead: "m_b242d975", caption: "m_9e5a3ac7", scrollContainer: "m_a100c15", scrollContainerInner: "m_62259741" };
function Bt(e, t) {
  if (!t)
    return;
  const r = {};
  return t.columnBorder && e.withColumnBorders && (r["data-with-column-border"] = !0), t.rowBorder && e.withRowBorders && (r["data-with-row-border"] = !0), t.striped && e.striped && (r["data-striped"] = e.striped), t.highlightOnHover && e.highlightOnHover && (r["data-hover"] = !0), t.captionSide && e.captionSide && (r["data-side"] = e.captionSide), t.stickyHeader && e.stickyHeader && (r["data-sticky"] = !0), r;
}
function ee(e, t) {
  const r = `Table${e.charAt(0).toUpperCase()}${e.slice(1)}`, o = ie((c, l) => {
    const n = le(r, {}, c), S = n, { classNames: d, className: u, style: m, styles: b } = S, h = x(S, ["classNames", "className", "style", "styles"]), i = Mt();
    return /* @__PURE__ */ s(
      K,
      f(f(f({
        component: e,
        ref: l
      }, Bt(i, t)), i.getStyles(e, { className: u, classNames: d, style: m, styles: b, props: n })), h)
    );
  });
  return o.displayName = `@mantine/core/${r}`, o.classes = ue, o;
}
const Pe = ee("th", { columnBorder: !0 }), lt = ee("td", { columnBorder: !0 }), be = ee("tr", {
  rowBorder: !0,
  striped: !0,
  highlightOnHover: !0
}), st = ee("thead", { stickyHeader: !0 }), at = ee("tbody"), ct = ee("tfoot"), it = ee("caption", { captionSide: !0 });
function Le({ data: e }) {
  return /* @__PURE__ */ q(vt, { children: [
    e.caption && /* @__PURE__ */ s(it, { children: e.caption }),
    e.head && /* @__PURE__ */ s(st, { children: /* @__PURE__ */ s(be, { children: e.head.map((t, r) => /* @__PURE__ */ s(Pe, { children: t }, r)) }) }),
    e.body && /* @__PURE__ */ s(at, { children: e.body.map((t, r) => /* @__PURE__ */ s(be, { children: t.map((o, c) => /* @__PURE__ */ s(lt, { children: o }, c)) }, r)) }),
    e.foot && /* @__PURE__ */ s(ct, { children: /* @__PURE__ */ s(be, { children: e.foot.map((t, r) => /* @__PURE__ */ s(Pe, { children: t }, r)) }) })
  ] });
}
Le.displayName = "@mantine/core/TableDataRenderer";
const Vt = {
  type: "scrollarea"
}, Yt = ze((e, { minWidth: t, type: r }) => ({
  scrollContainer: {
    "--table-min-width": xe(t),
    "--table-overflow": r === "native" ? "auto" : void 0
  }
})), Ee = ie((e, t) => {
  const r = le("TableScrollContainer", Vt, e), p = r, {
    classNames: o,
    className: c,
    style: l,
    styles: n,
    unstyled: d,
    vars: u,
    children: m,
    minWidth: b,
    type: h
  } = p, i = x(p, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "children",
    "minWidth",
    "type"
  ]), S = Ae({
    name: "TableScrollContainer",
    classes: ue,
    props: r,
    className: c,
    style: l,
    classNames: o,
    styles: n,
    unstyled: d,
    vars: u,
    varsResolver: Yt,
    rootSelector: "scrollContainer"
  });
  return /* @__PURE__ */ s(
    K,
    v(f(f(v(f({
      component: h === "scrollarea" ? de : "div"
    }, h === "scrollarea" ? { offsetScrollbars: "x" } : {}), {
      ref: t
    }), S("scrollContainer")), i), {
      children: /* @__PURE__ */ s("div", v(f({}, S("scrollContainerInner")), { children: m }))
    })
  );
});
Ee.classes = ue;
Ee.displayName = "@mantine/core/TableScrollContainer";
const Ut = {
  withRowBorders: !0,
  verticalSpacing: 7
}, jt = ze(
  (e, {
    layout: t,
    captionSide: r,
    horizontalSpacing: o,
    verticalSpacing: c,
    borderColor: l,
    stripedColor: n,
    highlightOnHoverColor: d,
    striped: u,
    highlightOnHover: m,
    stickyHeaderOffset: b,
    stickyHeader: h
  }) => ({
    table: {
      "--table-layout": t,
      "--table-caption-side": r,
      "--table-horizontal-spacing": Be(o),
      "--table-vertical-spacing": Be(c),
      "--table-border-color": l ? Te(l, e) : void 0,
      "--table-striped-color": u && n ? Te(n, e) : void 0,
      "--table-highlight-on-hover-color": m && d ? Te(d, e) : void 0,
      "--table-sticky-header-offset": h ? xe(b) : void 0
    }
  })
), _ = ie((e, t) => {
  const r = le("Table", Ut, e), te = r, {
    classNames: o,
    className: c,
    style: l,
    styles: n,
    unstyled: d,
    vars: u,
    horizontalSpacing: m,
    verticalSpacing: b,
    captionSide: h,
    stripedColor: i,
    highlightOnHoverColor: S,
    striped: p,
    highlightOnHover: A,
    withColumnBorders: C,
    withRowBorders: R,
    withTableBorder: H,
    borderColor: L,
    layout: Y,
    variant: P,
    data: V,
    children: N,
    stickyHeader: X,
    stickyHeaderOffset: y,
    mod: z,
    tabularNums: F
  } = te, O = x(te, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "horizontalSpacing",
    "verticalSpacing",
    "captionSide",
    "stripedColor",
    "highlightOnHoverColor",
    "striped",
    "highlightOnHover",
    "withColumnBorders",
    "withRowBorders",
    "withTableBorder",
    "borderColor",
    "layout",
    "variant",
    "data",
    "children",
    "stickyHeader",
    "stickyHeaderOffset",
    "mod",
    "tabularNums"
  ]), U = Ae({
    name: "Table",
    props: r,
    className: c,
    style: l,
    classes: ue,
    classNames: o,
    styles: n,
    unstyled: d,
    rootSelector: "table",
    vars: u,
    varsResolver: jt
  });
  return /* @__PURE__ */ s(
    It,
    {
      value: {
        getStyles: U,
        stickyHeader: X,
        striped: p === !0 ? "odd" : p || void 0,
        highlightOnHover: A,
        withColumnBorders: C,
        withRowBorders: R,
        captionSide: h || "bottom"
      },
      children: /* @__PURE__ */ s(
        K,
        v(f(f({
          component: "table",
          variant: P,
          ref: t,
          mod: [{ "data-with-table-border": H, "data-tabular-nums": F }, z]
        }, U("table")), O), {
          children: N || !!V && /* @__PURE__ */ s(Le, { data: V })
        })
      )
    }
  );
});
_.classes = ue;
_.displayName = "@mantine/core/Table";
_.Td = lt;
_.Th = Pe;
_.Tr = be;
_.Thead = st;
_.Tbody = at;
_.Tfoot = ct;
_.Caption = it;
_.ScrollContainer = Ee;
_.DataRenderer = Le;
const qt = "Table-module__root___5X62v", Jt = "Table-module__tableWrapper___voR20", Gt = "Table-module__table___VzDyA", Zt = "Table-module__thead___n9aOA", Qt = "Table-module__th___tq0gm", Kt = "Table-module__td___Js8My", er = "Table-module__tr___VNlrk", tr = "Table-module__tbody___5LXib", rr = "Table-module__columnSizeXs___3IYGB", or = "Table-module__columnSizeSm___jwj2y", nr = "Table-module__columnSizeMd___r6fY4", lr = "Table-module__columnSizeLg___wHLLt", sr = "Table-module__columnSizeXl___nejJ-", ar = "Table-module__columnSizeXxl___wIPEO", cr = "Table-module__sortIcon___573RG", ir = "Table-module__tableColumnAdjustment___AuboD", dr = "Table-module__cellContent___1JBZF", ur = "Table-module__fixedColumn___vqaAC", hr = "Table-module__fixedColumnShadow___-kAhx", mr = "Table-module__activeFilter___-r-fs", br = "Table-module__filterDropdown___gaD1E", fr = "Table-module__headerOptions___FovIA", pr = "Table-module__selectColumn___G3JkL", D = {
  root: qt,
  tableWrapper: Jt,
  table: Gt,
  thead: Zt,
  th: Qt,
  td: Kt,
  tr: er,
  tbody: tr,
  columnSizeXs: rr,
  columnSizeSm: or,
  columnSizeMd: nr,
  columnSizeLg: lr,
  columnSizeXl: sr,
  columnSizeXxl: ar,
  sortIcon: cr,
  tableColumnAdjustment: ir,
  cellContent: dr,
  fixedColumn: ur,
  fixedColumnShadow: hr,
  activeFilter: mr,
  filterDropdown: br,
  headerOptions: fr,
  selectColumn: pr
}, Xr = (A) => {
  var C = A, {
    data: e,
    columns: t,
    loading: r,
    emptyMessage: o = "No data available",
    itemsPerPage: c = 10,
    withPagination: l = !1,
    withItemsPerPageSelector: n = !1,
    itemsPerPageOptions: d = [10, 25, 50, 100],
    className: u,
    filterable: m = !1,
    selectable: b = !1,
    selectedRows: h = [],
    idField: i = "id",
    onSelectionChange: S
  } = C, p = x(C, [
    "data",
    "columns",
    "loading",
    "emptyMessage",
    "itemsPerPage",
    "withPagination",
    "withItemsPerPageSelector",
    "itemsPerPageOptions",
    "className",
    "filterable",
    "selectable",
    "selectedRows",
    "idField",
    "onSelectionChange"
  ]);
  const [R, H] = g(1), [L, Y] = g(c), [P, V] = g(null), [N, X] = g("asc"), [y, z] = g({}), [F, O] = g(null), [U, te] = g(!1), E = M(h), I = M(null);
  $(() => {
    E.current = h;
  }, [h]);
  const J = (a) => {
    const T = E.current.includes(a) ? E.current.filter((w) => w !== a) : [...E.current, a];
    E.current = T, S == null || S(T);
  }, re = () => {
    const a = G.map((k) => k[i]), T = a.every((k) => E.current.includes(k));
    let w;
    if (T)
      w = E.current.filter((k) => !a.includes(k));
    else {
      const k = new Set(E.current);
      a.forEach((j) => k.add(j)), w = Array.from(k);
    }
    E.current = w, S == null || S(w);
  }, ae = (a) => {
    Y(a), H(1);
  };
  wt(() => {
    const a = () => {
      if (I.current) {
        const w = I.current.scrollLeft > 1;
        te(w);
      }
    }, T = I.current;
    return T && (T.addEventListener("scroll", a), a()), () => {
      T && T.removeEventListener("scroll", a);
    };
  }, []);
  const oe = (a) => {
    P === a ? X(N === "asc" ? "desc" : "asc") : (V(a), X("asc"));
  }, ye = (a, T) => {
    z((w) => v(f({}, w), {
      [a]: T
    })), H(1);
  }, He = (a) => {
    O(F === a ? null : a);
  }, dt = (a) => {
    z((T) => {
      const w = f({}, T);
      return delete w[a], w;
    });
  }, he = Ue(() => {
    let a = [...e];
    return Object.keys(y).length > 0 && (a = a.filter((T) => Object.entries(y).every(([w, k]) => {
      if (!k) return !0;
      const j = t.find((bt) => bt.key === w), ce = j != null && j.filterValue ? j.filterValue(T) : T[w];
      return ce === void 0 ? !1 : String(ce).toLowerCase().includes(k.toLowerCase());
    }))), P && a.sort((T, w) => {
      const k = T[P], j = w[P];
      if (k === j) return 0;
      const ce = typeof k == "string" ? k.localeCompare(j) : k - j;
      return N === "asc" ? ce : -ce;
    }), a;
  }, [e, y, P, N, t]), ut = Math.ceil(he.length / L), We = (R - 1) * L, ht = We + L, G = l ? he.slice(We, ht) : he, mt = ({ content: a }) => /* @__PURE__ */ s(
    "div",
    {
      className: D.cellContent,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "100%"
      },
      children: a
    }
  );
  return /* @__PURE__ */ q(Me, { gap: "sm", className: u, children: [
    /* @__PURE__ */ s("div", { className: D.tableWrapper, ref: I, children: /* @__PURE__ */ q(_, v(f({ classNames: D }, p), { children: [
      /* @__PURE__ */ s(_.Thead, { className: D.thead, children: /* @__PURE__ */ q(_.Tr, { children: [
        b && /* @__PURE__ */ s(
          _.Th,
          {
            className: D.selectColumn,
            onClick: re,
            style: { cursor: "pointer" },
            children: /* @__PURE__ */ s(
              Ie,
              {
                label: "",
                checked: G.length > 0 && G.every((a) => E.current.includes(a[i])),
                indeterminate: G.some((a) => E.current.includes(a[i])) && !G.every((a) => E.current.includes(a[i])),
                onChange: (a) => {
                  a.stopPropagation(), re();
                },
                "aria-label": "Select all rows"
              }
            )
          }
        ),
        t.map((a) => /* @__PURE__ */ s(
          _.Th,
          {
            style: a.width ? { width: a.width } : void 0,
            className: `${a.className || ""} ${a.sortable ? D.sortableHeader : ""} ${a.filterable ? D.filterableHeader : ""} ${a.fixed ? `${D.fixedColumn} ${U ? D.fixedColumnShadow : ""}` : ""} ${a.key in D ? D[a.key] : ""}`,
            children: /* @__PURE__ */ q(Ve, { align: "center", gap: "xxs", children: [
              /* @__PURE__ */ s("div", { className: D.headerContent, children: a.header }),
              /* @__PURE__ */ q(Ve, { className: D.headerOptions, children: [
                a.sortable && /* @__PURE__ */ s(Oe, { label: P === a.key && N === "asc" ? "Sort descending" : "Sort ascending", children: /* @__PURE__ */ s(
                  ge,
                  {
                    variant: "tertiary",
                    onClick: () => oe(a.key),
                    className: P === a.key ? D.activeSort : "",
                    "aria-label": `Sort by ${a.header}`,
                    children: P === a.key && N === "desc" ? /* @__PURE__ */ s(_t, {}) : /* @__PURE__ */ s(Ct, {})
                  }
                ) }),
                a.filterable && m && /* @__PURE__ */ q(
                  we,
                  {
                    opened: F === a.key,
                    onChange: () => He(a.key),
                    position: "bottom-start",
                    closeOnClickOutside: !0,
                    closeOnEscape: !0,
                    children: [
                      /* @__PURE__ */ s(we.Target, { children: /* @__PURE__ */ s("div", { className: y[a.key] ? D.activeFilter : "", children: /* @__PURE__ */ s(Oe, { label: `Filter ${a.header}`, children: /* @__PURE__ */ s(
                        ge,
                        {
                          variant: "tertiary",
                          onClick: () => He(a.key),
                          "aria-label": `Filter ${a.header}`,
                          children: /* @__PURE__ */ s(Pt, { filled: !!y[a.key] })
                        }
                      ) }) }) }),
                      /* @__PURE__ */ s(we.Dropdown, { className: D.filterDropdown, children: /* @__PURE__ */ q(Me, { gap: "xs", children: [
                        /* @__PURE__ */ s(
                          Tt,
                          {
                            w: "100%",
                            label: "Filter",
                            value: y[a.key] || "",
                            onChange: (T) => ye(a.key, T.target.value)
                          }
                        ),
                        y[a.key] && /* @__PURE__ */ s(
                          ge,
                          {
                            variant: "tertiary",
                            onClick: () => dt(a.key),
                            "aria-label": "Clear filter",
                            leftSection: /* @__PURE__ */ s(xt, {}),
                            children: "Remove filter"
                          }
                        )
                      ] }) })
                    ]
                  }
                )
              ] })
            ] })
          },
          a.key
        ))
      ] }) }),
      /* @__PURE__ */ s(_.Tbody, { children: r ? /* @__PURE__ */ s(_.Tr, { children: /* @__PURE__ */ s(_.Td, { colSpan: t.length, align: "center", children: "Loading..." }) }) : G.length === 0 ? /* @__PURE__ */ s(_.Tr, { children: /* @__PURE__ */ s(_.Td, { colSpan: t.length, align: "center", children: o }) }) : G.map((a, T) => /* @__PURE__ */ q(_.Tr, { children: [
        b && /* @__PURE__ */ s(
          _.Td,
          {
            className: D.selectColumn,
            onClick: () => J(a[i]),
            style: { cursor: "pointer" },
            children: /* @__PURE__ */ s(
              Ie,
              {
                label: "",
                checked: E.current.includes(a[i]),
                onChange: (w) => {
                  w.stopPropagation(), J(a[i]);
                },
                "aria-label": `Select row ${T + 1}`
              }
            )
          }
        ),
        t.map((w, k) => /* @__PURE__ */ s(
          _.Td,
          {
            "data-cell-index": k,
            className: `${w.className || ""} ${w.fixed ? `${D.fixedColumn} ${U ? D.fixedColumnShadow : ""}` : ""}`,
            children: w.render ? w.render(a) : /* @__PURE__ */ s(mt, { content: String(a[w.key]) })
          },
          `${T}-${w.key}`
        ))
      ] }, T)) })
    ] })) }),
    l && /* @__PURE__ */ s(
      yt,
      {
        total: ut,
        value: R,
        onChange: H,
        withItemsPerPage: n,
        totalItems: he.length,
        itemsPerPage: L,
        itemsPerPageOptions: d,
        onItemsPerPageChange: ae
      }
    )
  ] });
};
export {
  Xr as Table
};
